import React, { useState, useEffect } from 'react';
import PageLayout from '../common/PageLayout';
import { convertXlsxToKoreanDB } from '../utils/api/productApi';
import { handleImportProcess } from '../utils/fileHandlers/importHandler';
import '../css/Step1.css';

function ConvertXlsxToKr() {
    const [error, setError] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [isConverting, setIsConverting] = useState(false);
    const [animatedText, setAnimatedText] = useState('Converting Xlsx to Korean DB');
    const [serverLogs, setServerLogs] = useState([]);

    useEffect(() => {
        if (isConverting) {
            let currentIndex = 0;
            const fullText = 'Converting Xlsx';
            const dots = '...';

            const timer = setInterval(() => {
                const numDots = (currentIndex % 4);  // 0에서 3까지 순환
                setAnimatedText(`${fullText}${dots.slice(0, numDots)}`);
                currentIndex++;
            }, 500);  // 타이머 간격을 500ms로 조정

            return () => clearInterval(timer);
        } else {
            setAnimatedText('Converting Xlsx to Korean DB and Japanese DB');  // converting 끝나면 원래 텍스트로
        }
    }, [isConverting]);

    const handleConvert = async () => {  // formData 파라미터 제거
        setError("");
        setStatusMessage("");
        setIsConverting(true);
        setServerLogs([]);
        try {
            const result = await handleImportProcess(() => convertXlsxToKoreanDB(), 'Korean DB Conversion');

            if (!result.success) {
                setStatusMessage(`변환 실패: ${result.message}`);
                return;
            }
            const logs = Array.isArray(result.data.details)
                ? result.data.details
                : [result.data.details];
            setServerLogs(logs);
            setStatusMessage("변환이 성공적으로 완료되었습니다.");
        } catch (error) {
            console.error('Error:', error);
            setError('변환 과정에서 오류가 발생했습니다.');
            setStatusMessage('변환 실패.');
        } finally {
            setIsConverting(false);
        }
    };


    return (
        <PageLayout
            title="Xlsx => Korean DB"
            description={
                <p className={`animated-text ${isConverting ? 'converting' : ''}`}>
                    {animatedText}
                </p>
            }
            onSubmit={handleConvert}
            isFileUpload={false}
            error={error}
            statusMessage={statusMessage}
            submitButtonText={isConverting ? "변환 중..." : "변환 시작"}
        >
            {/* children으로 서버 로그를 전달 */}
            {serverLogs.length > 0 && (
                <div className="server-logs-container">
                    <h3>서버 로그</h3>
                    <div className="server-logs">
                        {serverLogs.map((log, index) => (
                            <div key={index} className="log-line">
                                {log}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </PageLayout>
    );
}

export default ConvertXlsxToKr;